module.exports = __webpack_public_path__ + "img/empty.6587ec49.png";